import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, User } from '../../services/user.service';
import { ContractorService } from '../../services/contractor.service';
import { ProfileService } from '../../services/profile.service';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchbarService } from '../../services/searchbar.service';

@Component({
  selector: 'contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.scss']
})
export class ContractorComponent implements OnInit {
  steps = [];
  me = new User();
  fileTypes = {
    display: [],
    all: []
  }
  contractors = { 'all': [], 'display': [] };
  profileId = null;
  currentFilter = null;
  showHidden = false;

  constructor(private _contractorService: ContractorService, private _router: Router, private _user: UserService,
    private _profile: ProfileService, private _searchService: SearchbarService,
    private _notification: NotificationService, public translate: TranslateService) {
    this.steps.push({ name: [translate.instant('TOOLBAR.STEP.CONTRACTOR')], ref: ["contractor"] })
  }

  ngOnInit() {

    if (!this._user.isLoggedIn()) {
      this._router.navigate([''], { queryParams: { redirect: 'contractor' } });
    } else {
      this._profile.me().subscribe((profile: any) => {
        this.profileId = profile._id;
        this.populateTable();
      });
    }
  }

  populateTable() {
    this._contractorService.getMine()
      .subscribe(
        (contractors: any) => {
          // .filter(x => !x.shared)
          contractors = contractors.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
          });
          this.contractors.all = contractors;
          this.contractors.display = contractors;
          /*if (this.currentFilter) {
            console.log("research", this.currentFilter);
            this.filterContractor(this.currentFilter);
          }*/
          this.addContractor();
        },
        this._notification.errorServer
      );
  }

  isReadOnly(line){
    if (line.profile && this.profileId != line.profile._id){
      return true;
    }
    return false;
  }

  nameChanged(value, i) {
    console.log("change value", event, i, this.contractors.display.length, i == this.contractors.display.length - 1);
    if (value && i == this.contractors.display.length - 1) {
      console.log("add line");
      this.addContractor();
    }
  }

  filterContractor(filter) {
    this.currentFilter = filter;
    //console.log("filter contractors", filter);
    this._searchService.filter(this.contractors, filter);
  }

  saveContractors() {
    this._contractorService.updateContractors(this.profileId, this.contractors.all)
      .subscribe(c => {
        this.contractors.all = [];
        console.log("contractors saved", c);
        this.populateTable();

      });
  }

  addContractor() {
    console.log("add contractor contracto", this.profileId);
    this.contractors.all.push({ name: '', email: '', phone: '', hidden: false });
    this.contractors.display.push({ name: '', email: '', phone: '', hidden: false });
  }

}
